<template>
    <div>
        <v-text-field dense label="Question" outlined v-model="question" @keyup="emitChange()"></v-text-field>
        <v-textarea label="Answer" rows="3" v-model="answer" outlined @keyup="emitChange()" />
    </div>
</template>

<script>
  export default {
    components: {},
    name: "FormText",
    data() {
      return {
        radiogroup: undefined,
        answer:undefined,
        question: undefined
      }
    },
    mounted() {
    },
    methods: {
      emitChange(){
        this.$emit('formData',{question: this.question, answer: this.answer})
      }
    }
  }
</script>

<style scoped>

</style>